const capitalize = (string) =>
  string[0].toUpperCase() + string.slice(1).toLowerCase();

export { capitalize };
